import styled from 'styled-components';
import { Row } from 'components/shared/Layout';
import { BREAKPOINTS } from 'constants/breakpoints';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const ButtonRow = styled(Row)`
  display: flex;
  flex-direction: row;
  gap: 22px;
  width: fit-content;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    gap: 16px;
  }
`;
